import {Directive, effect, inject, Input, signal, TemplateRef, ViewContainerRef} from '@angular/core';
import {FeatureFlagKey} from '@/app/core/models/feature-flag/featureFlagKey';
import {FeatureFlagService} from '@services/feature-flag.service';

@Directive({
	selector: '[featureFlag]',
	standalone: true
})
export class FeatureFlagDirective {
	private templateRef = inject(TemplateRef);
	private viewContainer = inject(ViewContainerRef);
	private featureFlagService = inject(FeatureFlagService);

	private currentFeature = signal<FeatureFlagKey | undefined>(undefined);
	private elseTemplateRef?: TemplateRef<any>;

	constructor() {
		effect(() => {
			const feature = this.currentFeature();
			this.featureFlagService.getFeatureFlags();
			if (feature) {
				this.updateView(feature);
			}
		});
	}

	@Input() set featureFlag(feature: FeatureFlagKey) {
		this.currentFeature.set(feature);
	}

	@Input() set featureFlagElse(elseTemplateRef: TemplateRef<any>) {
		this.elseTemplateRef = elseTemplateRef;
	}

	private updateView(feature: FeatureFlagKey): void {
		const isEnabled = this.featureFlagService.isEnabled(feature);

		this.viewContainer.clear();

		if (isEnabled) {
			this.viewContainer.createEmbeddedView(this.templateRef);
		} else if (this.elseTemplateRef) {
			this.viewContainer.createEmbeddedView(this.elseTemplateRef);
		}
	}
}
